import React from "react";
import { useAppContext } from "../../AppProvider";
import { ButtonUtility } from "../../Components/common/Buttons/ButtonUtility";
import { ButtonDelete } from "../../Components/common/Buttons/ButtonDelete";
import {
  useWarehouseArticleSettingsDeleteContext,
  useWarehouseArticleSettingsHandlerContext,
} from "./provider/hooks";

const WarehouseArticleSettingsDelete: React.FC<{ onBack?: () => void }> = ({
  onBack,
}) => {
  const { dictionary } = useAppContext();
  const { data, loader, deleteWarehouseArticleSettings } =
    useWarehouseArticleSettingsDeleteContext();
  const { modalConfig } = useWarehouseArticleSettingsHandlerContext();

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col">
          <h3 className="text-center">
            {modalConfig.title || dictionary.actions.delete}
          </h3>
          <label className="label-5 text-center">
            {data?.length && data.length > 1
              ? dictionary.messages.ask_to_delete_selected
              : dictionary.messages.ask_to_delete}
          </label>
        </div>
      </div>
      <div className="d-flex">
        <ButtonUtility
          className="w-50 me-2"
          onClick={() => {
            if (onBack) {
              onBack();
            }
          }}
        >
          {dictionary.words.back}
        </ButtonUtility>
        <ButtonDelete
          className="w-50"
          onClick={() => deleteWarehouseArticleSettings()}
          disabled={loader}
          loading={loader}
        >
          {dictionary.actions.delete}
        </ButtonDelete>
      </div>
    </React.Fragment>
  );
};

export default WarehouseArticleSettingsDelete;
